// extracted by mini-css-extract-plugin
export var attachment = "_rj-a";
export var emailContainer = "_rj-4";
export var emailContentPaddedContainer = "_rj-b";
export var emailHeader = "_rj-6";
export var emailIframe = "_rj-3";
export var emailInfoIcon = "_rj-9";
export var emailShortenedSummary = "_rj-e";
export var infoDropdown = "_rj-0";
export var infoRowBoundedContent = "_rj-d";
export var internal = "_rj-5";
export var merchant = "_rj-8";
export var messageInputContainer = "_rj-h";
export var normal = "_rj-7";
export var replyCard = "_rj-f";
export var subtleButton = "_rj-1";
export var subtleButtonIconContainer = "_rj-2";
export var toggleViewRepliesButton = "_rj-c";
export var wrappingText = "_rj-g";